import { DeepPartial, IdentifierSuggestionsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_IDENTIFIER_SUGGESTIONS: DeepPartial<IdentifierSuggestionsConfig> = {
  components: { container: 'CdlSuggestions' },
  size: 12
};
